import dict from '../../dictionary';
import cData from '../../reducedData.json';
import trans from '../../translations.json';

const getPopupContent = (featureName, lang, mode, isPerCapita) => {
  if (mode === dict.phu) {
    return getPopupContentPhu(featureName, lang, mode, isPerCapita);
  }
};

const getPopupContentPhu = (lhinNameEn, lang, mode, isPerCapita) => {
  if (lhinNameEn) {
    const phuData = cData.dataLHIN[lhinNameEn.toUpperCase()];
    let data = [
      phuData[dict.hospitalizations],
      phuData[dict.ICU],
      phuData[dict.ICU_vented],
    ];

    if (isPerCapita) {
      data = data.map((datapoint) =>
        datapoint !== 0
          ? (
              (datapoint /
                dict.LHIN_population[lhinNameEn.toUpperCase()]) *
              100000
            ).toFixed(2)
          : datapoint,
      );
    }

    // set the popup content
    const popupContent = `<Popup>
      <b>${trans.LHIN[lhinNameEn.toUpperCase()][lang]}</b>
      ${
        phuData
          ? `<p>
          ${trans.viewModes.hospitalized[lang]}: ${data[0]}<br>
          ${trans.viewModes.inICU[lang]}: ${data[1]}<br>
          ${trans.viewModes.bedsTaken[lang]}: ${data[2]}<br>
          </p>`
          : trans.heatmap.phuDNE[lang]
      }
      </Popup>`;

    return popupContent;
  }
};

// const getPopupContentFsa = (fsaName, lang, mode, isPerCapita) => {
//   const fsaData = cData.dataFSA[fsaName];
//   /**
//  *  "FSA": "K2P",
//             "ACTIVE_CASES": "3",
//             "RATE_PER_100K": "16.8"
//  */
//   // set the popup content
//   const popupContent = `<Popup>
//       <b>${fsaName}</b>
//       <p>
//         ${trans.heatmap.active[lang]}: ${
//     fsaData?.ACTIVE_CASES || 0
//   } (${fsaData?.RATE_PER_100K || 0} per 100k people) <br />

//         </p>
//       </Popup>`;

//   return popupContent;
// };

export { getPopupContent };
